import React from "react";
import { Col, Row } from "antd";
import {
  FieldTimeOutlined,
  IdcardOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { startDateInfo } from "../utils/date";

const EmployeeTerminationModalInfo = ({ employee }) => {
  const startDate = employee.current_record?.timespan.lower;

  return (
    <Row style={{ width: "100%" }}>
      <EmployeeInfoCell
        icon={<MailOutlined />}
        info={employee.email}
        label={"E-mail"}
      />
      <EmployeeInfoCell
        icon={<IdcardOutlined />}
        info={employee.employee_code}
        label={"Código"}
      />
      <EmployeeInfoCell
        icon={<FieldTimeOutlined />}
        info={startDateInfo(startDate)}
        label={startDate ? `Ativo ${startDate.fromNow()}` : "-"}
      />
    </Row>
  );
};

const EmployeeInfoCell = ({ icon, info, label }) => (
  <Col sm={24} md={24} lg={8} style={{ width: "100%", marginBottom: 12 }}>
    <Row>
      <Col>{icon}</Col>
      <Col style={{ marginLeft: 12 }}>
        <Row>
          <Col>{info}</Col>
        </Row>
        <Row>
          <Col>{label}</Col>
        </Row>
      </Col>
    </Row>
  </Col>
);

export default EmployeeTerminationModalInfo;
